import { cn } from "@/app/common/common-functions/functions";
import { LoaderCircle } from "lucide-react";

export type NewLoaderProps = Parameters<typeof LoaderCircle>[0] & {
  iconOnly?: boolean;
  text?: string;
};

const NewLoader = ({ className, iconOnly, text }: NewLoaderProps) => {
  if (!iconOnly) {
    return (
      <div className="tw-flex tw-h-48 tw-w-full tw-flex-col tw-items-center tw-justify-center tw-gap-4">
        <LoaderCircle className={cn("tw-h-10 tw-w-10 tw-animate-spin", className)} />
        {text && <p>{text}</p>}
      </div>
    );
  }

  return <LoaderCircle className={cn("tw-m-auto tw-h-10 tw-w-10 tw-animate-spin", className)} />;
};

export default NewLoader;
